import Clickable from 'components/Common/Clickable'
import LineInfoCircleIcon from 'LuxKit/Icons/line/LineInfoCircleIcon'
import BodyTextBlock from 'LuxKit/TextBlocks/BodyTextBlock'
import type { TourStyledProductTypeInfoModalResult } from 'components/Tours/TourStyledProductTypeInfoModal'
import TourStyledProductTypeInfoModal from 'components/Tours/TourStyledProductTypeInfoModal'
import ModalContext from 'contexts/ModalContext'
import { isTourProductTypeStyled } from 'lib/tours/tourUtils'
import type { MouseEventHandler } from 'react'
import { useCallback, useContext } from 'react'
import { useIntl } from 'react-intl'
import useTourStyledLabels from 'hooks/Tours/useTourStyledLabels'

interface Props {
  productType: App.Tours.V2ProductTypeStyled
  onCheckAvailability: () => void
}

function TourStyleTag({ productType, onCheckAvailability }: Props) {
  const intl = useIntl()
  const { styledProductTypeTitles } = useTourStyledLabels()
  const showModal = useContext(ModalContext)
  const openTourStyleInfoModal = useCallback<MouseEventHandler<HTMLButtonElement>>(async(event) => {
    event.preventDefault()
    const result = await showModal<TourStyledProductTypeInfoModalResult>(<TourStyledProductTypeInfoModal
      primaryActionText={intl.formatMessage({
        id: '-rq6UyM2yQK0T5lTKY3Q',
        defaultMessage: 'Check availability',
        description: 'Primary action button text to check tour availability',
      })}
      productType={productType}
    />)
    if (result === 'primary-action') {
      onCheckAvailability()
    }
  }, [intl, onCheckAvailability, showModal, productType])

  if (!isTourProductTypeStyled(productType)) return null

  return <BodyTextBlock
    variant="large"
    endIcon={productType !== 'custom_tour' && <Clickable onClick={openTourStyleInfoModal}><LineInfoCircleIcon /></Clickable>}
  >
    {intl.formatMessage(
      {
        id: 'mixazqSy4Iai1Jau3mB8',
        defaultMessage: 'Tour style: {tourStyleTitle}',
        description: 'Label displaying the tour style type on the tour offer page',
      },
      { tourStyleTitle: styledProductTypeTitles[productType] },
    )}
  </BodyTextBlock>
}

export default TourStyleTag
